import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PasswordGuard implements CanActivate {

  token : string | null = '';

  constructor(private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    this.token = sessionStorage.getItem('email');
    if (this.token) {
      return of(true);
    } else {
      return of(this.router.createUrlTree(['/home']));
    }
  }
}
